import { render, staticRenderFns } from "./m_groupDiscussion.vue?vue&type=template&id=03b06b7e&scoped=true&"
import script from "./m_groupDiscussion.vue?vue&type=script&lang=js&"
export * from "./m_groupDiscussion.vue?vue&type=script&lang=js&"
import style0 from "./m_groupDiscussion.vue?vue&type=style&index=0&id=03b06b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b06b7e",
  null
  
)

export default component.exports